(function () {

function $parcel$extendImportMap(map) {
  Object.assign(parcelRequire.i ??= {}, map);
}

var $parcel$bundleURL;
function $parcel$resolve(url) {
  url = parcelRequire.i?.[url] || url;
  if (!$parcel$bundleURL) {
    try {
      throw new Error();
    } catch (err) {
      var matches = ('' + err.stack).match(
        /(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^)\n]+/g,
      );
      if (matches) {
        $parcel$bundleURL = matches[0];
      } else {
        return $parcel$distDir + url;
      }
    }
  }
  return new URL($parcel$distDir + url, $parcel$bundleURL).toString();
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  var $parcel$distDir = "./";

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequireca82"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequireca82"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
var $2a115ddcf1b03c80$exports = {};
$parcel$extendImportMap({
    "c1i2w": "bagolie.781ab5d0.jpg",
    "hMSn4": "collazos-gill.9391a449.jpg",
    "kCPtA": "mckeon.7cd05ba2.jpg",
    "kxVuW": "sherrill.2aff8029.jpg",
    "ktS8j": "laux.dc0fb9b8.jpg"
});

/** Resolved at bundle time so img.src is always a URL string (Parcel can break default imports inside large object literals). */ var $ce0a16f1f8ce9c35$exports = {};
$ce0a16f1f8ce9c35$exports = $parcel$resolve("c1i2w");


var $619e2120f710c59b$exports = {};
$619e2120f710c59b$exports = $parcel$resolve("hMSn4");


var $ecfdb73537d2e93e$exports = {};
$ecfdb73537d2e93e$exports = $parcel$resolve("kCPtA");


var $66b3b2d406086590$exports = {};
$66b3b2d406086590$exports = $parcel$resolve("kxVuW");


var $46751a74ef92bf21$exports = {};
$46751a74ef92bf21$exports = $parcel$resolve("ktS8j");


const $62ba8797dfef5f1b$var$officialPhotoUrls = {
    bagolie: new URL($ce0a16f1f8ce9c35$exports).href,
    collazosgill: new URL($619e2120f710c59b$exports).href,
    mckeon: new URL($ecfdb73537d2e93e$exports).href,
    sherrill: new URL($66b3b2d406086590$exports).href,
    laux: new URL($46751a74ef92bf21$exports).href
};
const $62ba8797dfef5f1b$var$officials = {
    bagolie: {
        label: 'Assemblywoman Rosy Bagolie',
        salutation: 'Assemblywoman Bagolie',
        email: 'AswBagolie@njleg.org',
        phone: '(973) 535-5017',
        dial: '9735355017',
        localPhoto: $62ba8797dfef5f1b$var$officialPhotoUrls.bagolie,
        profileRole: 'Vice-Chair, Assembly Education Committee; also on Financial Institutions & Insurance Committee. Current Principal/Superintendent of Schools, East Newark Public School.',
        profileContext: "As Vice-Chair of the Assembly Education Committee, she's positioned to shape what school funding legislation looks like and how quickly it moves \u2014 and as Principal/Superintendent of Schools, she understands the math districts like ours are facing."
    },
    collazosgill: {
        label: 'Assemblywoman Alixon Collazos-Gill',
        salutation: 'Assemblywoman Collazos-Gill',
        email: 'AswCollazos-Gill@njleg.org',
        phone: '(973) 509-0388',
        dial: '9735090388',
        localPhoto: $62ba8797dfef5f1b$var$officialPhotoUrls.collazosgill,
        profileRole: "General Assembly, District 27 \u2014 Deputy Conference Leader.",
        profileContext: "As Deputy Conference Leader and a member of the Children, Families and Food Security Committee, she's part of Assembly leadership and works on issues that directly affect West Orange families \u2014 making her a key voice for getting school funding onto the caucus's agenda."
    },
    mckeon: {
        label: 'Senator John McKeon',
        salutation: 'Senator McKeon',
        email: 'SenMcKeon@njleg.org',
        phone: '(862) 930-7071',
        dial: '8629307071',
        localPhoto: $62ba8797dfef5f1b$var$officialPhotoUrls.mckeon,
        profileRole: 'Former Mayor of West Orange.',
        profileContext: "As a former Mayor of West Orange, he knows our district from the inside \u2014 and as our State Senator, he's our path into the Senate, where any Assembly reform has to pass to become law."
    },
    sherrill: {
        label: 'Governor Mikie Sherrill',
        salutation: 'Governor Sherrill',
        contactFormUrl: 'https://www-njlib.nj.gov/GOV_TRANS_APPLICANTS/BTCustomServlet',
        phone: '(609) 292-6000',
        dial: '6092926000',
        localPhoto: $62ba8797dfef5f1b$var$officialPhotoUrls.sherrill
    },
    laux: {
        label: 'Commissioner Lily Laux',
        salutation: 'Commissioner Laux',
        email: 'commissioner@doe.nj.gov',
        phone: 'Email preferred',
        dial: '',
        localPhoto: $62ba8797dfef5f1b$var$officialPhotoUrls.laux
    }
};
let $62ba8797dfef5f1b$var$selectedOfficialKey = 'bagolie';
let $62ba8797dfef5f1b$var$activeMode = 'email';
const $62ba8797dfef5f1b$var$subjectLine = "Subject: New Jersey school funding crisis \u2014 concerns from a West Orange parent";
const $62ba8797dfef5f1b$var$BAGOLIE_OPTIONAL_BODY = "As a member of the Assembly Education Committee, you're in a position to shape what reform looks like and how quickly it moves. West Orange parents have appreciated your engagement with our community, and we're eager to hear what's on the committee's agenda for school funding this session \u2014 and how parents in your district can support that work.";
function $62ba8797dfef5f1b$var$buildEmailMessage(official) {
    const fullName = document.getElementById('fullName').value.trim() || '[Your Full Name]';
    const address = document.getElementById('address').value.trim();
    const contactEmail = document.getElementById('contactEmail').value.trim();
    const addressLine = address || '[Address]';
    const emailLine = contactEmail || '[Email]';
    const bagolieBlock = $62ba8797dfef5f1b$var$selectedOfficialKey === 'bagolie' ? `\n\n${$62ba8797dfef5f1b$var$BAGOLIE_OPTIONAL_BODY}` : '';
    return `${$62ba8797dfef5f1b$var$subjectLine}

Dear ${official.salutation},

My name is ${fullName}, and I'm a West Orange parent and voter. Our district just closed this year's budget gap through painful cuts to staff, programs, and class sizes. But the underlying math is still broken: state-mandated costs keep rising faster than the 2% levy cap allows our local revenue to grow.

This isn't a West Orange problem. Districts across New Jersey are facing the same compounding gap, year after year, because the School Funding Reform Act (SFRA) hasn't been meaningfully updated since 2008. Without action in Trenton, the same cuts will repeat next year, and the year after, in district after district.

I'm writing to ask: what solutions are you working on to address this crisis?

I'd like to know what reforms you're considering, what bills you're supporting or planning to introduce, and what your timeline is for action. I'd also welcome the chance to share what's happening in West Orange and hear what you're seeing from other districts in your region.${bagolieBlock}

Our kids deserve a plan. I hope you'll share yours.

Sincerely,
${fullName}
West Orange parent and voter
${addressLine}
${emailLine}`;
}
function $62ba8797dfef5f1b$var$buildPhoneScript(official) {
    const fullName = document.getElementById('fullName').value.trim() || '[Your Name]';
    const contactEmail = document.getElementById('contactEmail').value.trim();
    const voicemailCallback = contactEmail || '[your phone or email]';
    return `Hi, my name is ${fullName}, and I'm a voter and parent in West Orange calling as part of West Orange Parents for Education, a community group of over 600 parents concerned about the school funding crisis.

Our district just passed a budget that eliminated approximately 77 positions, raised class sizes, and cut middle school sports \u{2014} and the underlying problem is still there. State-mandated costs keep rising faster than the 2% levy cap allows us to raise revenue. Without action in Trenton, the same cuts will happen again next year, and the year after.

This isn't just a West Orange problem. Districts across New Jersey are facing the same compounding gap because the School Funding Reform Act hasn't been meaningfully updated since 2008.

I'm calling to ask: what solutions is ${official.salutation} working on to address this crisis?

I'd like to know what reforms they're considering, what bills they're supporting or planning to introduce, and what their timeline is for action.

[If you reach a person:] Could you let me know how I can expect to hear back \u{2014} by email, a return call, or a public statement?

[If you reach voicemail:] I'd appreciate a return call or email at ${voicemailCallback}. Thank you.`;
}
async function $62ba8797dfef5f1b$var$copyText(text) {
    await navigator.clipboard.writeText(text);
}
function $62ba8797dfef5f1b$var$renderOfficialButtons() {
    document.querySelectorAll('.official-btn').forEach((button)=>{
        const isActive = button.dataset.officialKey === $62ba8797dfef5f1b$var$selectedOfficialKey;
        button.classList.toggle('bg-navy', isActive);
        button.classList.toggle('text-white', isActive);
        button.classList.toggle('border-navy', isActive);
        button.classList.toggle('bg-white', !isActive);
        button.classList.toggle('text-gray-700', !isActive);
        button.classList.toggle('border-gray-300', !isActive);
    });
}
function $62ba8797dfef5f1b$var$updateProfilePhoto(official) {
    const profilePhoto = document.getElementById('profilePhoto');
    profilePhoto.alt = `${official.label} portrait`;
    profilePhoto.src = official.localPhoto;
}
function $62ba8797dfef5f1b$var$renderProfile(official) {
    document.getElementById('profileName').textContent = official.label;
    const profileEmail = document.getElementById('profileEmail');
    profileEmail.target = '';
    profileEmail.rel = '';
    if (official.contactFormUrl) {
        profileEmail.href = official.contactFormUrl;
        profileEmail.target = '_blank';
        profileEmail.rel = 'noopener noreferrer';
        profileEmail.textContent = "Governor's office web form";
        profileEmail.classList.remove('hidden');
    } else if (official.email) {
        profileEmail.removeAttribute('target');
        profileEmail.removeAttribute('rel');
        profileEmail.href = `mailto:${official.email}`;
        profileEmail.textContent = official.email;
        profileEmail.classList.remove('hidden');
    } else {
        profileEmail.removeAttribute('href');
        profileEmail.textContent = '';
        profileEmail.classList.add('hidden');
    }
    const phoneLink = document.getElementById('profilePhone');
    if (official.dial) {
        phoneLink.href = `tel:${official.dial}`;
        phoneLink.classList.remove('pointer-events-none', 'opacity-60', 'text-gray-600', 'no-underline');
        phoneLink.classList.add('text-blue-700', 'underline');
        phoneLink.textContent = official.phone;
    } else {
        phoneLink.href = '#';
        phoneLink.classList.add('pointer-events-none', 'opacity-60', 'text-gray-600', 'no-underline');
        phoneLink.classList.remove('text-blue-700', 'underline');
        phoneLink.textContent = official.phone || 'Not listed';
    }
    $62ba8797dfef5f1b$var$updateProfilePhoto(official);
    const ctxWrap = document.getElementById('profileLegislatorContext');
    const roleEl = document.getElementById('profileLegislatorRole');
    const ctxEl = document.getElementById('profileLegislatorContextText');
    const hasRole = official.profileRoleHtml || official.profileRole;
    const hasCtx = official.profileContext;
    if (!hasRole && !hasCtx) {
        ctxWrap.classList.add('hidden');
        roleEl.textContent = '';
        roleEl.innerHTML = '';
        ctxEl.textContent = '';
    } else {
        ctxWrap.classList.remove('hidden');
        if (official.profileRoleHtml) roleEl.innerHTML = official.profileRoleHtml;
        else if (official.profileRole) {
            roleEl.innerHTML = '';
            roleEl.textContent = official.profileRole;
        } else {
            roleEl.innerHTML = '';
            roleEl.textContent = '';
        }
        roleEl.classList.toggle('hidden', !hasRole);
        ctxEl.textContent = official.profileContext || '';
        ctxEl.classList.toggle('hidden', !official.profileContext);
    }
}
function $62ba8797dfef5f1b$var$renderModeButtons() {
    const emailBtn = document.getElementById('modeEmailBtn');
    const phoneBtn = document.getElementById('modePhoneBtn');
    const openEmailBtn = document.getElementById('openEmailBtn');
    const isGovernor = $62ba8797dfef5f1b$var$selectedOfficialKey === 'sherrill';
    const officialsEntry = $62ba8797dfef5f1b$var$officials[$62ba8797dfef5f1b$var$selectedOfficialKey];
    const usesForm = !!officialsEntry.contactFormUrl;
    emailBtn.textContent = usesForm ? 'Web form' : 'Email';
    const isEmail = $62ba8797dfef5f1b$var$activeMode === 'email';
    emailBtn.className = isEmail ? 'rounded-md bg-red-600 px-4 py-2 text-sm font-semibold text-white' : 'rounded-md px-4 py-2 text-sm font-semibold text-gray-700';
    phoneBtn.className = !isEmail ? 'rounded-md bg-red-600 px-4 py-2 text-sm font-semibold text-white' : 'rounded-md px-4 py-2 text-sm font-semibold text-gray-700';
    openEmailBtn.classList.toggle('hidden', !isEmail);
    openEmailBtn.textContent = usesForm ? 'Open contact form' : 'Open Email Draft';
}
function $62ba8797dfef5f1b$var$renderTemplate() {
    const official = $62ba8797dfef5f1b$var$officials[$62ba8797dfef5f1b$var$selectedOfficialKey];
    $62ba8797dfef5f1b$var$renderOfficialButtons();
    $62ba8797dfef5f1b$var$renderProfile(official);
    $62ba8797dfef5f1b$var$renderModeButtons();
    const stepThreeLabel = document.getElementById('stepThreeLabel');
    if (stepThreeLabel) stepThreeLabel.textContent = official.contactFormUrl ? 'Web form / Call' : 'Send Email / Call';
    document.getElementById('messageTemplate').value = $62ba8797dfef5f1b$var$activeMode === 'email' ? $62ba8797dfef5f1b$var$buildEmailMessage(official) : $62ba8797dfef5f1b$var$buildPhoneScript(official);
}
document.addEventListener('DOMContentLoaded', ()=>{
    const fields = [
        'fullName',
        'school',
        'address',
        'contactEmail'
    ];
    fields.forEach((id)=>{
        document.getElementById(id).addEventListener('input', $62ba8797dfef5f1b$var$renderTemplate);
    });
    document.querySelectorAll('.official-btn').forEach((button)=>{
        button.addEventListener('click', ()=>{
            $62ba8797dfef5f1b$var$selectedOfficialKey = button.dataset.officialKey;
            $62ba8797dfef5f1b$var$renderTemplate();
        });
    });
    document.getElementById('modeEmailBtn').addEventListener('click', ()=>{
        $62ba8797dfef5f1b$var$activeMode = 'email';
        $62ba8797dfef5f1b$var$renderTemplate();
    });
    document.getElementById('modePhoneBtn').addEventListener('click', ()=>{
        $62ba8797dfef5f1b$var$activeMode = 'phone';
        $62ba8797dfef5f1b$var$renderTemplate();
    });
    document.getElementById('copyMessageBtn').addEventListener('click', async ()=>{
        const status = document.getElementById('actionStatus');
        const official = $62ba8797dfef5f1b$var$officials[$62ba8797dfef5f1b$var$selectedOfficialKey];
        try {
            await $62ba8797dfef5f1b$var$copyText(document.getElementById('messageTemplate').value);
            if ($62ba8797dfef5f1b$var$activeMode === 'email') status.textContent = official.contactFormUrl ? "Message copied. Paste into the governor's web form." : 'Email copied to clipboard.';
            else status.textContent = 'Phone script copied to clipboard.';
        } catch (error) {
            status.textContent = 'Copy failed. Please copy manually.';
        }
    });
    document.getElementById('openEmailBtn').addEventListener('click', ()=>{
        const official = $62ba8797dfef5f1b$var$officials[$62ba8797dfef5f1b$var$selectedOfficialKey];
        if (official.contactFormUrl) {
            window.open(official.contactFormUrl, '_blank');
            return;
        }
        const content = document.getElementById('messageTemplate').value;
        const subject = content.split('\n')[0].replace('Subject: ', '');
        const body = content.split('\n').slice(1).join('\n').trim();
        window.location.href = `mailto:${official.email}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
    });
    $62ba8797dfef5f1b$var$renderTemplate();
});

})();
//# sourceMappingURL=take-action.f5bdf777.js.map
